import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_FIRST_DELIVERY: "Din første levering",
      CHOOSE_DAY: "Velg dag",
      CHOOSE_TIME: "Velg tid",
      DELIVERY_TIME: "Leveringstid",
      NIGHT_TIME_DELIVERY_WARNING:
        "Obs! Nattlevering kan bety at matkassen din blir satt ut uten tilsyn i lengre tid.",
      SAVE_CHNAGES_BUTTON: "Lagre endringer",
      CANCEL_BUTTON: "Avbryt",
      NO_DELIVERY_ON_SELECTED_ADDRESS_FOR_THIS_WEEK:
        "Dessverre er det ingen leveringstider til denne adressen i den valgte uken.",
    },
    se: {
      YOUR_FIRST_DELIVERY: "Din första leverans",
      CHOOSE_DAY: "Välj dag",
      CHOOSE_TIME: "Välj tid",
      DELIVERY_TIME: "Leveranstid",
      NIGHT_TIME_DELIVERY_WARNING:
        "Notera att leverans på natten kan innebära att paketet står utan tillsyn utomhus en längre period.",
      SAVE_CHNAGES_BUTTON: "Spara ändringar",
      CANCEL_BUTTON: "Avbryt",
      NO_DELIVERY_ON_SELECTED_ADDRESS_FOR_THIS_WEEK:
        "Tyvärr finns inga leveranstider till ditt område under vald vecka.",
    },
    dk: {
      YOUR_FIRST_DELIVERY: "Din første levering",
      CHOOSE_DAY: "Vælg dag",
      CHOOSE_TIME: "Vælg tidspunkt",
      DELIVERY_TIME: "Leveringstid",
      NIGHT_TIME_DELIVERY_WARNING:
        "Bemærk venligst! Natlevering kan betyde, at din måltidskasse bliver sat udenfor uden opsyn i længere tid.",
      SAVE_CHNAGES_BUTTON: "Gem ændringer",
      CANCEL_BUTTON: "Afbryd",
      NO_DELIVERY_ON_SELECTED_ADDRESS_FOR_THIS_WEEK:
        "Desværre er der ingen leveringstider til denne adresse i den valgte uge.",
    },
  } as const
)[language];
